import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../../components/contentwrapper/ContentWrapper'
import { activeStatus, fetchCallAllDataByIDAPI } from '../../utils/api'
import Skeleton from 'react-loading-skeleton'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { Table } from 'react-bootstrap'

const AllProcessName = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [process, setProcess] = useState([])
    const ppcid = localStorage.getItem('ppcdata')
    const [searchSkill, setSearchSkill] = useState('')

    useEffect(() => {
        getProcessDetails(ppcid)
    }, [ppcid])

    const getProcessDetails = async (ppcid) => {
        setIsLoading(true)
        try {
            const res = await fetchCallAllDataByIDAPI(`ppc-team-get-all-process-name-by-id/${ppcid}`)
            if (res?.data?.status === 1) {
                const list = res?.data?.process
                // Ensure we always set an array
                setProcess(Array.isArray(list) ? list : (list ? [list] : []))
            } else {
                setProcess([])
            }
        } catch (e) {
            console.error('getProcessDetails error:', e)
            setProcess([])
        } finally {
            setIsLoading(false)
        }
    }

    const filteredProcess = useMemo(() => {
        const q = (searchSkill || '').toLowerCase()
        if (!q) return process
        return process.filter((item) => {
            const skill = (item?.skillname || '').toLowerCase()
            const display = (item?.display || '').toLowerCase()
            const language = (item?.language || '').toLowerCase()
            const product = (item?.product || '').toLowerCase()
            const handle = (item?.handle || '').toLowerCase()
            return (
                skill.includes(q) ||
                display.includes(q) ||
                language.includes(q) ||
                product.includes(q) ||
                handle.includes(q)
            )
        })
    }, [process, searchSkill])

    const totals = useMemo(() => {
        return filteredProcess.reduce(
            (acc, cur) => {
                acc.unique += Number(cur?.unique_calls || 0)
                acc.total += Number(cur?.total_calls || 0)
                return acc
            },
            { unique: 0, total: 0 }
        )
    }, [filteredProcess])

    const handleToggleStatus = async (processId, currentStatus) => {
        const newStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';

        try {
            // IMPORTANT: send flat fields (id, status)
            const res = await activeStatus('ppc-update-process-name-status', { id: processId, status: newStatus });
            const { status, id, new_status } = res?.data || {};

            if (status === 1 && id && new_status) {
                // IMMUTABLE update on the base state, not on filteredProcess
                setProcess(prev =>
                    prev.map(row => {
                        // coerce types so we actually match
                        const rowId = Number(row?.process_id);
                        const targetId = Number(id);
                        if (rowId === targetId) {
                            // return a NEW object with updated status
                            return { ...row, process_status: new_status };
                        }
                        return row;
                    })
                );
            } else {
                console.warn('Toggle failed or invalid response:', res?.data);
            }
        } catch (e) {
            console.error('updatePPCProcessStatus error:', e);
        }
    };

    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR::ALL PROCESS</title>
            </Helmet>
            <ContentWrapper>
                <div className="card hrpages">
                    <div className="heading p-2 d-flex justify-content-between">
                        <h5 className="mb-0 text-uppercase" style={{ fontWeight: "600" }}>All Process Name(Till Date)</h5>
                        <div style={{ width: '25%' }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Skill Name, Language, Product and Handle By..."
                                value={searchSkill}
                                onChange={(e) => setSearchSkill(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Skill Name</th>
                                    <th>Mobile</th>
                                    <th>Language</th>
                                    <th>Product</th>
                                    <th>Handle By</th>
                                    <th>Total Unique Call</th>
                                    <th>Total Call</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {isLoading ? (
                                    [...Array(10)].map((_, i) => (
                                        <tr key={i}>
                                            {Array.from({ length: 9 }).map((_, idx) => (
                                                <td key={idx}>
                                                    <Skeleton animation="wave" />
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                ) : filteredProcess.length > 0 ? (
                                    filteredProcess.map((item, index) => (
                                        <tr key={`${item?.process_id || 'row'}-${index}`}>
                                            <td>{index + 1}</td>
                                            <td>{item?.skillname || '-'}</td>
                                            <td>{item?.display || '-'}</td>
                                            <td>{item?.language || '-'}</td>
                                            <td>{item?.product || '-'}</td>
                                            <td>{item?.handle || '-'}</td>
                                            <td>{Number(item?.unique_calls || 0)}</td>
                                            <td>{Number(item?.total_calls || 0)}</td>
                                            <td>
                                                <span
                                                    className={`badge ${item?.process_status === 'Active' ? 'bg-success' : 'bg-secondary'}`}
                                                    role="button"
                                                    onClick={() => handleToggleStatus(item?.process_id, item?.process_status)}
                                                >
                                                    {item?.process_status || '-'}
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={9} className="text-center">
                                            No matching skills found...
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                            <tfoot>
                                <tr>
                                    <th colSpan={6} className="text-end" style={{ fontWeight: "700", fontSize: "14px", letterSpacing: "0.8px" }}>Totals</th>
                                    <th style={{ fontWeight: "700", fontSize: "14px", letterSpacing: "0.8px" }}>{totals.unique}</th>
                                    <th style={{ fontWeight: "700", fontSize: "14px", letterSpacing: "0.8px" }}>{totals.total}</th>
                                    <th></th>
                                </tr>
                            </tfoot>
                        </Table>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default AllProcessName
